import { IoMdDownload } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button } from "@headlessui/react";

export default function MobAdminEmpOldDocument({
  documents = [],
  onDownload,
  onDelete,
  onTogglePublish,
}) {
  if (!documents.length) {
    return (
      <p className="text-center text-gray-500 text-sm py-6">
        No documents found
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className="relative bg-white border border-gray-300 rounded-lg p-4 shadow-sm"
        >
          {/* Document Name */}
          <p className="text-xs text-gray-500">Document Name</p>
          <p className="text-sm font-medium">{doc.documentName}</p>

          {/* File Name */}
          <p className="text-xs text-gray-500 mt-2">File Name</p>
          <p className="text-sm break-all">{doc.fileName}</p>

          {/* Doc Type */}
          <p className="text-xs text-gray-500 mt-2">Doc Type</p>
          <p className="text-sm capitalize">{doc.documentType}</p>

          {/* Upload Date */}
          <p className="text-xs text-gray-500 mt-2">Upload Date</p>
          <p className="text-sm">{doc.uploadDate}</p>

          {/* Uploaded By */}
          {doc.uploadBy && (
            <>
              <p className="text-xs text-gray-500 mt-2">Uploaded By</p>
              <p className="text-sm">{doc.uploadBy}</p>
            </>
          )}

          {/* Publish / Unpublish */}
          <div className="mt-3">
            <Button
              onClick={() => onTogglePublish(doc.id, doc.isPublished)}
              className={`!w-28 !text-xs !font-medium !capitalize ${
                !doc.isPublished
                  ? "!text-red-600 border border-red-400 hover:!bg-red-500 hover:!text-white"
                  : "!text-green-600 border border-green-400 hover:!bg-green-500 hover:!text-white"
              }`}
            >
              {doc.isPublished ? "Unpublish" : "Publish"}
            </Button>
          </div>

          {/* ACTION ICONS — bottom right */}
          <div className="absolute bottom-3 right-3 flex gap-2">
            <button
              onClick={() => onDownload(doc)}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-100 text-blue-600"
            >
              <IoMdDownload size={18} />
            </button>

            <button
              onClick={() => onDelete(doc.id)}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-red-100 text-red-600"
            >
              <RiDeleteBin6Line size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
